module.exports = __webpack_public_path__ + "static/living_room_day_mobile-cd4fddd31afbbe575749ac34daf40012.jpg";